import React from 'react';
import PropTypes from 'prop-types';

const ErrorComponent = (props) => {
    const { stack, data } = props;

    return (
        <body>
            <h1>Error</h1>
            {__DEV__ && (
                <div>
                    <pre
                        style={{
                            fontSize: '20px'
                        }}
                    >
                        {stack}
                    </pre>
                    <pre
                        style={{
                            padding: '10px',
                            margin: '40px 20px',
                            fontSize: '14px',
                            backgroundColor: '#f9f9f9'
                        }}
                    >
                        {JSON.stringify(data, null, 4)}
                    </pre>
                </div>
            )}
        </body>
    );
};

ErrorComponent.defaultProps = {
    data: {}
};

ErrorComponent.propTypes = {
    data: PropTypes.object,
    stack: PropTypes.string.isRequired
};

export default ErrorComponent;
